import { CAREERS_URL } from "../../navigation/config/navConfig";

export type FooterLink = {
  title: string;
  href: string;
  isExternal?: boolean;
};

export type FooterSection = {
  title: string;
  links: FooterLink[];
};

export const companyLinks: FooterSection = {
  title: "Company",
  links: [
    {
      title: "Contact",
      href: "/contact",
    },
    {
      title: "HIPAA NPP",
      href: "/hipaa_notice.pdf",
      isExternal: true,
    },
    {
      title: "Careers",
      href: CAREERS_URL,
      isExternal: true,
    },
  ],
};

export const socialLinks: FooterSection = {
  title: "Social",
  links: [
    {
      title: "LinkedIn",
      href: "https://www.linkedin.com/company/versemed/",
      isExternal: true,
    },
  ],
};

export const legalLinks: FooterLink[] = [
  {
    title: "Patient Rights",
    href: "/patient-rights-page",
  },
  {
    title: "Terms of Service",
    href: "/terms-of-service",
  },
];
